<template>
  <div>
    <div class="selectPackage white" v-if="flow">
      <div style="overflow: hidden">
        <v-row justify="center" class="mt-5" v-if="$vuetify.breakpoint.mdAndUp">
          <v-col cols="10">
            <div>
              <v-row class="mt-5">
                <v-col cols="12" lg="3" class="">
                  <DoctorSideBarPayment @backToTime="backToTime" :selected_time="selected_time" :therapist="therapist"/>
                </v-col>
                <v-col cols="12" lg="9" class="">

                  <!--                  <div class="hintArea">-->
                  <!--                    <div class="titleHintArea d-flex">-->
                  <!--                      <div>-->
                  <!--                        <img src="../../assets/image/user-journey/checkbox.svg" alt="">-->
                  <!--                      </div>-->
                  <!--                      <div class="mr-2">-->
                  <!--                        ویژگی های برگزاری جلسات با تیم سیمیاروم-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="contentHint">-->
                  <!--                      <v-row class="pa-0 ma-0 mt-4">-->
                  <!--&lt;!&ndash;                        <v-col cols="12" class="ma-0 pa-0" lg="6">&ndash;&gt;-->
                  <!--&lt;!&ndash;                          <div class="hintItem d-flex">&ndash;&gt;-->
                  <!--&lt;!&ndash;                            <img src="../../assets/image/user-journey/check.svg" alt="">&ndash;&gt;-->
                  <!--&lt;!&ndash;                            <div class="mr-2">&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <b>&ndash;&gt;-->
                  <!--&lt;!&ndash;                                بازگشت تمام وجه&ndash;&gt;-->
                  <!--&lt;!&ndash;                              </b>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              در صورت عدم رضایت، بعد از جلسه اول&ndash;&gt;-->
                  <!--&lt;!&ndash;                            </div>&ndash;&gt;-->
                  <!--&lt;!&ndash;                          </div>&ndash;&gt;-->
                  <!--&lt;!&ndash;                        </v-col>&ndash;&gt;-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              بررسی اثربخشی جلسات به صورت مستمر-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              همراهی تیم تخصصی ارزیابی جلسات-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                        <v-col cols="12" class="ma-0 pa-0" lg="4">-->
                  <!--                          <div class="hintItem d-flex">-->
                  <!--                            <img src="../../assets/image/user-journey/check.svg" alt="">-->
                  <!--                            <div class="mr-2">-->
                  <!--                              امکان تغییر تراپیست-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </v-col>-->
                  <!--                      </v-row>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="blueHint">
                    <div class="d-flex">
                      <div>
                        <img src="../../assets/image/user-journey/info-circle.png" alt="">
                      </div>
                      <div class="mr-2">
                        زمان و تراپیست انتخاب شده تا
                        <b>
                          یک ساعت
                        </b>
                        برای شما محفوظ خواهد ماند.
                      </div>
                    </div>
                  </div>
                  <div class="contentPresession mt-5 mb-10">
                    <b>
                      برای تکمیل رزرو جلسه‌تان، لطفاً پکیج موردنظر را از بین گزینه‌های زیر انتخاب و پرداخت کنید.
                    </b>
                  </div>
                  <CadPricingNotice v-if="showCadNotice"/>
                  <div class="packageArea ">

                    <v-row>
                      <v-col cols="12" lg="6">
                        <div class="newUserPackage">
                          <div class="newCustomer">
                            ویژه مراجعین جدید
                          </div>
                          <div class="d-flex justify-space-between">
                            <div class="titlePackage">
                              بسته 3جلسه ای شروع مسیر
                            </div>
                            <div>
                              <div class="offBadge">
                                40% تخفیف
                              </div>
                            </div>
                          </div>
                          <div class="priceBox" v-if="hasPrice(starterPackage)">
                            <div class="oldPrice" v-if="starterCompareAtPrice">
                              <span class="en_num">{{ formatAmount(starterCompareAtPrice) }}</span>
                              <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                            </div>
                            <div class="d-flex">
                              <div class="newPrice">
                                <span class="en_num">{{ formatAmount(starterPackage.price) }}</span>
                                <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                              </div>
                              <div class="perSession d-flex flex-column justify-center mr-5">
                                <div>
                                  <span class="enFont">
                                    {{ formatAmount(starterPackage.single_session_price) }}
                                  </span>
                                  <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                                  / به ازای هر جلسه
                                </div>
                              </div>
                            </div>
                            <div class="previousUsdHint" v-if="showUsdComparison && starterPackage.usd_price">
                              <i18n path="packages.previouslyUsd">
                                <span place="price" class="en_num">{{ formatAmount(starterPackage.usd_price) }}</span>
                              </i18n>
                            </div>
                            <div class="">
                              <v-btn
                                  color="primary"
                                  class="submitBtn"
                                  elevation="0"
                                  @click="selectPackage(197)"
                              >
                                خرید بسته
                              </v-btn>
                              <div class="refund">
                                <b>
                                  بازگشت تمام وجه
                                </b>
                                در صورت عدم رضایت، بعد از جلسه اول
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <template>
                        <v-col cols="12" lg="6" v-if="flow.is_student">
                          <div class="oldUserPackage fill-height  d-flex flex-column">
                            <div class="d-flex justify-space-between">
                              <div class="titlePackage">
                                یک جلسه مشاوره (ویژه دانشجویان)
                              </div>
                              <div>

                              </div>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="priceBox" v-if="hasPrice(studentPackage)">
                              <div class="oldPrice" v-if="hasPrice(regularSinglePackage)">
                                <span class="en_num">{{ formatAmount(regularSinglePackage.price) }}</span>
                                <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                              </div>
                              <div class="d-flex">

                                <div class="newPrice">
                                  <span class="en_num">{{ formatAmount(studentPackage.price) }}</span>
                                  <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                                </div>
                                <div class="perSession d-flex flex-column justify-center mr-5">
                                  <div>
                                    /
                                    جلسه
                                  </div>
                                </div>
                              </div>
                              <div class="previousUsdHint" v-if="showUsdComparison && studentPackage.usd_price">
                                <i18n path="packages.previouslyUsd">
                                  <span place="price" class="en_num">{{ formatAmount(studentPackage.usd_price) }}</span>
                                </i18n>
                              </div>
                              <div class="">
                                <v-btn
                                    outlined
                                    color="primary"
                                    class="submitBtnOutline"
                                    elevation="0"
                                    @click="selectPackage(255)"

                                >
                                  خرید بسته
                                </v-btn>
                                <div class="refund">
                                  <b>
                                    بازگشت تمام وجه
                                  </b>
                                  در صورت عدم رضایت، بعد از جلسه اول
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" lg="6" v-else>
                          <div class="oldUserPackage fill-height  d-flex flex-column" v-if="hasPrice(segmentPackage)">
                            <div class="d-flex justify-space-between">
                              <div class="titlePackage">
                                یک جلسه مشاوره روانشناسی
                              </div>
                              <div>

                              </div>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="priceBox">
                              <div class="d-flex">
                                <div class="newPrice">
                                  <span class="en_num">{{ formatAmount(segmentPackage.price) }}</span>
                                  <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                                </div>
                                <div class="perSession d-flex flex-column justify-center mr-5 ">
                                  <div>
                                    /
                                    جلسه
                                  </div>
                                </div>
                              </div>
                              <div class="previousUsdHint" v-if="showUsdComparison && segmentPackage.usd_price">
                                <i18n path="packages.previouslyUsd">
                                  <span place="price" class="en_num">{{ formatAmount(segmentPackage.usd_price) }}</span>
                                </i18n>
                              </div>

                            </div>
                            <div class="">
                              <v-btn
                                  outlined
                                  color="primary"
                                  class="submitBtnOutline"
                                  elevation="0"
                                  @click="selectPackage(segmentPackage.id)"
                              >
                                خرید بسته
                              </v-btn>
                              <div class="refund">
                                <b>
                                  بازگشت تمام وجه
                                </b>
                                در صورت عدم رضایت، بعد از جلسه اول
                              </div>

                            </div>
                          </div>
                        </v-col>

                      </template>
                      <v-col cols="12" v-if="flow.is_student && hasPrice(studentPackage)">
                        <div class=" d-flex mt-1">
                          <div>
                            <img src="../../assets/image/user-journey/info-circle-filled.svg" alt="">
                          </div>
                          <div class="mr-1 hintAreaStudent">
                            در صورتی که دانشجو هستید هزینه جلسات
                            <b>
                              تا پایان دوره تراپی
                            </b>
                            به ازای هر جلسه
                            <b>
                              <span class="en_num">{{ formatAmount(studentPackage.price) }}</span>
                              <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                            </b>
                            خواهد بود.
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>

        </v-row>
        <div class="mobileArea " v-else>
          <DoctorSideBarPayment @backToTime="backToTime" :selected_time="selected_time" :therapist="therapist"/>
          <div class="whiteBox">
            <div class="hintArea">
              <div class="contentHint">
                <v-row class="pa-0 ma-0 ">
                  <v-col cols="12" class="ma-0 pa-0" lg="6">
                    <div class="hintItem d-flex">
                      <img src="../../assets/image/user-journey/check.svg" alt="">
                      <div class="mr-2">
                        <b>
                          بازگشت تمام وجه
                        </b>
                        در صورت عدم رضایت، بعد از جلسه اول
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" class="ma-0 pa-0" lg="6">
                    <div class="hintItem d-flex">
                      <img src="../../assets/image/user-journey/check.svg" alt="">
                      <div class="mr-2">
                        بررسی اثربخشی جلسات به صورت مستمر
                      </div>
                    </div>


                  </v-col>

                </v-row>
              </div>
            </div>
            <div>
              <CadPricingNotice v-if="showCadNotice" class="mt-4"/>
              <div class="packageArea ">
                <v-row>
                  <v-col cols="12" lg="6">
                    <div class="newUserPackage">
                      <div class="newCustomer">
                        ویژه مراجعین جدید
                      </div>
                      <div class="d-flex justify-space-between">
                        <div class="titlePackage">
                          بسته 3جلسه ای شروع مسیر
                        </div>
                        <div>
                          <div class="offBadge">
                            40% تخفیف
                          </div>
                        </div>
                      </div>
                      <div class="priceBox" v-if="hasPrice(starterPackage)">
                        <div class="oldPrice" v-if="starterCompareAtPrice">
                          <span class="en_num">{{ formatAmount(starterCompareAtPrice) }}</span>
                          <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                        </div>
                        <div class="d-flex">
                          <div class="newPrice">
                            <span class="en_num">{{ formatAmount(starterPackage.price) }}</span>
                            <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                          </div>
                          <div class="perSession d-flex flex-column justify-center mr-5 mt-2">
                            <div>
                                  <span class="enFont">
                                {{ formatAmount(starterPackage.single_session_price) }}
                              </span>
                              <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                              / به ازای هر جلسه
                            </div>
                          </div>
                        </div>
                        <div class="previousUsdHint" v-if="showUsdComparison && starterPackage.usd_price">
                          <i18n path="packages.previouslyUsd">
                            <span place="price" class="en_num">{{ formatAmount(starterPackage.usd_price) }}</span>
                          </i18n>
                        </div>
                        <div class="">
                          <v-btn
                              color="primary"
                              class="submitBtn"
                              elevation="0"
                              @click="selectPackage(197)"

                          >
                            خرید بسته
                          </v-btn>
                          <div class="refund">
                            <b>
                              بازگشت تمام وجه
                            </b>
                            در صورت عدم رضایت، بعد از جلسه اول
                          </div>

                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" v-if="!flow.is_student">
                    <div class="oldUserPackage fill-height  d-flex flex-column" v-if="hasPrice(segmentPackage)">
                      <div class="d-flex justify-space-between">
                        <div class="titlePackage">
                          یک جلسه مشاوره روانشناسی
                        </div>
                        <div>

                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="priceBox">
                        <div class="d-flex">
                          <div class="newPrice">
                            <span class="en_num">{{ formatAmount(segmentPackage.price) }}</span>
                            <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                          </div>
                          <div class="perSession d-flex flex-column justify-center mr-5">
                            <div>
                              /
                              جلسه
                            </div>
                          </div>
                        </div>
                        <div class="previousUsdHint" v-if="showUsdComparison && segmentPackage.usd_price">
                          <i18n path="packages.previouslyUsd">
                            <span place="price" class="en_num">{{ formatAmount(segmentPackage.usd_price) }}</span>
                          </i18n>
                        </div>

                      </div>
                      <div class="">
                        <v-btn
                            outlined
                            color="primary"
                            class="submitBtnOutline"
                            elevation="0"
                            @click="selectPackage(segmentPackage.id)"

                        >
                          خرید بسته
                        </v-btn>
                        <div class="refund">
                          <b>
                            بازگشت تمام وجه
                          </b>
                          در صورت عدم رضایت، بعد از جلسه اول
                        </div>

                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" v-else>
                    <div class="oldUserPackage fill-height  d-flex flex-column" v-if="hasPrice(studentPackage)">
                      <div class="d-flex justify-space-between">
                        <div class="titlePackage">
                          یک جلسه مشاوره (ویژه دانشجویان)
                        </div>
                        <div>

                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <div class="priceBox">
                        <div class="oldPrice" v-if="hasPrice(regularSinglePackage)">
                          <span class="en_num">{{ formatAmount(regularSinglePackage.price) }}</span>
                          <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                        </div>
                        <div class="d-flex">
                          <div class="newPrice">
                            <span class="en_num">{{ formatAmount(studentPackage.price) }}</span>
                            <span class="currencyLabel">{{ journeyCurrencyLabel }}</span>
                          </div>
                          <div class="perSession d-flex flex-column justify-center mr-5">
                            <div>
                              /
                              جلسه
                            </div>
                          </div>
                        </div>
                        <div class="previousUsdHint" v-if="showUsdComparison && studentPackage.usd_price">
                          <i18n path="packages.previouslyUsd">
                            <span place="price" class="en_num">{{ formatAmount(studentPackage.usd_price) }}</span>
                          </i18n>
                        </div>

                      </div>
                      <div class="">
                        <v-btn
                            outlined
                            color="primary"
                            class="submitBtnOutline"
                            elevation="0"
                            @click="selectPackage(255)"

                        >
                          خرید بسته
                        </v-btn>
                        <div class="refund">
                          <b>
                            بازگشت تمام وجه
                          </b>
                          در صورت عدم رضایت، بعد از جلسه اول
                        </div>

                      </div>
                    </div>
                  </v-col>
                </v-row>
                <div class="text-center mt-8">
                  <img src="../../assets/image/user-journey/hipa.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--      <PreSessionBox text="اگر همچنان سوال یا ابهامی در مسیر انتخاب تراپیست دارید، کارشناسان ما همراه شما هستند"-->
      <!--                     class="mt-15"/>-->


    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import DoctorSideBarPayment from "@/components/UserJourney/DoctorSideBarPayment.vue";
import PreSessionBox from "@/components/UserJourney/PreSessionBox.vue";
import CadPricingNotice from "@/components/Packages/CadPricingNotice.vue";
import EventsMixins from "@/mixins/EventsMixins";
import {resolveJourneyToken, clearJourneyStorage} from "@/utils/journeyToken";
/*eslint-disable*/
export default {
  mixins:[EventsMixins],
  components: {CadPricingNotice, PreSessionBox, DoctorSideBarPayment},
  props: {
    therapist: Object,
    flow: Object,
    selected_time: Object,
    sessionToken: String,
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
    starterPackage() {
      return this.journeyPackage(197);
    },
    studentPackage() {
      return this.journeyPackage(255);
    },
    regularSinglePackage() {
      return this.journeyPackage(68);
    },
    segmentPackage() {
      if (!this.segmentId) {
        return null;
      }
      return this.journeyPackage(this.segmentId);
    },
    journeyCurrency() {
      const pkg = this.starterPackage
        || this.studentPackage
        || this.segmentPackage
        || this.regularSinglePackage;
      return (pkg && pkg.currency) || null;
    },
    journeyCurrencyLabel() {
      return this.currencyShortLabel(this.journeyCurrency);
    },
    showCadNotice() {
      return this.journeyCurrency === 'cad';
    },
    showUsdComparison() {
      return this.journeyCurrency && this.journeyCurrency !== 'dollar';
    },
    starterCompareAtPrice() {
      const single = this.regularSinglePackage;
      const starter = this.starterPackage;
      if (!this.hasPrice(single) || !starter || !starter.session_count) {
        return null;
      }
      return roundToTwo(Number(single.price) * Number(starter.session_count));
    },
  },
  data() {
    return {
      abVariant: null,
      segmentId: null,
      journeyPackages: {},
      variantPackageIds: {
        pricing_A: 326,
        pricing_B: 327,
        pricing_C: 68,
      },
    }
  },
  methods: {
    journeyPackage(id) {
      if (!id) {
        return null;
      }
      return this.journeyPackages[String(id)] || null;
    },
    hasPrice(pkg) {
      return !!(pkg && Number(pkg.price) > 0);
    },
    currencyShortLabel(currency) {
      switch (currency) {
        case 'dollar':
          return this.$t('currency.dollar');
        case 'cad':
          return this.$t('currency.dollarCanada');
        case 'aud':
          return this.$t('currency.dollarAustralia');
        case 'euro':
          return this.$t('currency.Euro');
        case 'gbp':
          return this.$t('currency.pound');
        case 'try':
          return this.$t('currency.try');
        case 'rial':
          return this.$t('currency.rial');
        default:
          return '';
      }
    },
    formatAmount(value) {
      const amount = Number(value);
      if (Number.isNaN(amount)) {
        return '';
      }
      const formatted = amount.toFixed(2).replace(/\.00$/, "");
      return formatted;
    },
    getFlowDetail() {
      const token = resolveJourneyToken(this.sessionToken)
      if (!token) {
        this.$emit('restartTest')
        return
      }
      this.$emitEvent('setLoading', true)
      this.requesting('setSession', 'getFlowDetail', {}, {
        token
      }).then((resp) => {
        this.journeyPackages = resp.data.journey_packages || {};
        this.abVariant = (resp.data.flow && resp.data.flow.ab_variant) || null;
        const variant = this.abVariant ?? 'pricing_C';
        this.segmentId = this.variantPackageIds[variant] || this.variantPackageIds.pricing_C;
      }).catch((error) => {
        const status = error && error.response && error.response.status
        const payload = error && error.response && error.response.data
        const errorCode = payload && payload.data && payload.data.error_code
        if (status === 403 || errorCode === 'FLOW_OWNERSHIP_MISMATCH' || status === 400) {
          this.$emit('restartTest')
        }
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    backToTime() {
      this.$emit('backToTime')
    },
    selectPackage(package_id) {
      const token = resolveJourneyToken(this.sessionToken)
      if (!token) {
        this.$emit('restartTest')
        return
      }
      this.$emitEvent('setLoading', true)
      this.SendEventTrk({
        event_id: 'user_journey_' + Date.now(),
        name: 'journey_pay',
        email: this.profile.email,
        first_name: this.profile.firstname,
        last_name: this.profile.lastname,
        payload: {
          package_id: package_id,
          ab_variant: this.abVariant,
          effective_ab_variant: this.abVariant ?? 'pricing_C',
        }
      })
      this.requesting('setSession', 'selectPackage', {}, {
        token,
        package_id: package_id,
      }).then((resp) => {

        clearJourneyStorage()
        window.location = resp.data.payment.url

        // this.requesting('factor', 'payFactor', {factorID: resp.data.cart.id}).then((res) => {
        //   if (res.data.state == 'SUCCESS') {
        //     localStorage.removeItem('set_session_token')
        //     window.location = res.data.url
        //   }
        // })
      }).catch(() => {
        this.$emitEvent('setLoading', false)
      }).finally(() => {
        // this.$emitEvent('setLoading', false)
      })
    },
  },
  filters: {

    weekDayName(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("dddd");
    },
    getTime(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("HH:mm");
    },
    getShortMonth(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").locale('en').format("MMM");
    },
    dayNumber(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").format("DD");
    },
    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/sDD - [ساعت] hh:mm');
    },
    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/sDD ');
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format(' [ساعت] hh:mm');
    },
    jalaliDateTimeWithoutLabel(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('  hh:mm');
    },

  },
  mounted() {

    this.getFlowDetail()

    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 100)

    this.user = JSON.parse(JSON.stringify(this.profile))

    let times = JSON.parse(JSON.stringify(this.timezones));

    this.timezonesList = times.map((item) => {
      item.text = item.text + '  ' + moment.tz(item.text).format('Z');
      return item;
    });

    this.timezoneResultList = this.timezonesList
  },

}

function roundToTwo(value) {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}
</script>

<style>


@media (min-width: 200px) and (max-width: 1000px) {
  .mobileArea {
    margin-bottom: 20px;
  }

  .hintItem {
    font-size: 13px !important;
    margin-bottom: 0px !important;
  }

  .hintArea {
    padding: 16px 10px !important;
  }

  .offBadge {
    font-size: 10px !important;
  }

  .titlePackage {
    font-size: 18px !important;
  }

  .oldPrice {
    font-size: 16px !important;
  }

  .newPrice {
    font-size: 32px !important;
  }

  .perSession {
    font-size: 14px !important;
  }
}

a {
  text-decoration: none;
}

@media (min-width: 200px) and (max-width: 1000px) {
  .presessionBtn {
    margin-top: 20px;
  }

  .titlePresession {
    font-size: 16px !important;
  }
}

.presessionBtn {
  color: rgba(57, 201, 144, 1);
  border: 1px solid rgba(57, 201, 144, 1);
  border-radius: 8px;
  background: white;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 20px;
}

.presessionBtn:hover {
  background: rgba(0, 0, 0, 0.01);
  transition: all 0.3s;
}

.titlePresession {
  font-weight: 700;
  font-size: 20px;
}

.contentPresession {
  font-weight: 500;
  font-size: 16px;
}

.presessionBox {
  background: rgba(215, 244, 233, 0.5);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: -13px;
}


.refund {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-top: 15px;
}

.perSession {
  color: #757575;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.enFont {
  font-family: Roboto !important;
}

.priceBox {
  margin-top: 24px;
}

.previousUsdHint {
  margin-top: 8px;
  color: #757575;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}

.currencyLabel {
  font-family: main !important;
}

.oldPrice {
  font-family: Roboto !important;
  color: #757575;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: line-through;
}

.newPrice {
  font-family: Roboto !important;
  color: #424242;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.offBadge {
  border-radius: 16px;
  background: #FFECDF;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  height: 32px;
  display: flex;
  flex-direction: column;
  color: #FF852E;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.packageArea {
  margin-top: 20px;
}

.newUserPackage {
  position: relative;
  border-radius: 8px;
  border: 2px solid #39C990;
  background: #FFF;
  padding: 32px 24px 24px 24px;
}

.oldUserPackage {
  position: relative;
  border-radius: 8px;
  border: 1px solid #DBE4ED;
  background: #FFF;
  padding: 32px 24px 24px 24px;
}

.newCustomer {
  border-radius: 16px;
  background: #39C990;
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 120px;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: -18px;
}

.titlePackage {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.hintArea {
  padding: 16px;
  border-radius: 8px;
  background: rgba(197, 239, 254, 0.20);
}

.hintItem {
  color: #212121;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  margin-bottom: 16px;
}

.titleHintArea {
  color: #212121;
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.submitBtn {
  border-radius: 8px;
  background: #39C990 !important;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}

.submitBtnOutline {
  border-radius: 8px;
  width: 100%;
  height: 48px !important;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 45px;
}

.hintAreaStudent {
  color: #035184;
  font-weight: 500;
  font-size: 14px;
}

.blueHint {
  background: rgba(197, 239, 254, 0.5);
  padding: 14px 16px 5px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(3, 81, 132, 1);
}
</style>